import { API_URL } from "../Config";
import { PageResult } from "../Pagination";

export interface IIncidentEmissionParameterResult {
  incidentemissionsparameterresultid: string;
  parameter: string;
  value: number;
  sampletype: string;
  elv: string;
  incidentid: string;
  date: string;
}

export interface IIncidentEmissionParameterResultsList extends PageResult {
  list: IIncidentEmissionParameterResult[];
}

export const GetIncidentEmissionParameterResultsFetchUrl = (
  incidentId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}`;
  var filterParams = "";
  if (searchText && searchText.length > 0) {
    filterParams += `&search_term=${encodeURIComponent(searchText)}`;
  }

  let url = `${API_URL}/Incident/incidentemissionparameterslist?incident_id=${incidentId}${filterParams}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/incident-emission-parameter-results`;
  }

  return url;
};
